// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill';
import Vue from 'vue';
import i18n from './locale';
import ElementUI from 'element-ui'; // 引入ui
import 'element-ui/lib/theme-chalk/index.css'; // 引入ui
import App from './App';
import store from './store';
import router from './router';
import './assets/css/main.css';
import './assets/css/element_elevidence.css';
import elSelectDirectives from './util/elSelectDirectives';
import VueDOMPurifyHTML from 'vue-dompurify-html';
Vue.use(VueDOMPurifyHTML);
Vue.use(ElementUI, {
  size: 'small'
}); // 引入ui
Vue.use(elSelectDirectives)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  i18n,
  router,
  store,
  components: { App },
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js